//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Vyp.WebControls.VypraveniSettingsForm.ts                 </Name>
//    <Description> Uživatelské nastavení zásilek.                              </Description>
//    <Author>      JSindelka                                                      </Author>
//    <Copyright>   © GORDIC spol. s r. o. 1993-2018                            </Copyright>
//    <Created>     2018-05-22                                                  </Created>
//  </FileHeader>

namespace Gordic.Vyp.AppSettings {

    enum fieldNames {
        stat = "stat",
        psc = "psc",
        frankovani_podaci_cislo = "frankovani_podaci_cislo",
        frankovani_pretridit = "frankovani_pretridit",
        tridit_dle_souboru = "tridit_dle_souboru",
        kontrolovat_spravnost_dle_souboru = "kontrolovat_spravnost_dle_souboru",
        opravit_data_dle_souboru = "opravit_data_dle_souboru",
        pouzivat_soubor_bez_pidu = "pouzivat_soubor_bez_pidu",
        frankovat_pri_prevzeti = "frankovat_pri_prevzeti"
    }

    /**
     * Cesta k objetu nastavení zásilky v GStore.
     * 
     * @author  JSindelka
     * @date    30.04.2019
     */
    export const VypraveniSettingsPath = "Global.Vyp.AppSettings.VypraveniSettings"

    /**
 * Vrátí hodnoty uživatelského nastavení zásilky.
 *
 * @author  JSindelka
 * @date    30.04.2019
 *  
 * @returns {Gordic.Vyp.WebControls.GVypraveniSettingsDto} Hodnoty uživatelského nastavení zásilky.
 */
    export function GetVypraveniSettings(content: GContent): Gordic.Wfl.Interface.GVypraveniSettingsDto
    {
        const settings: Gordic.Wfl.Interface.GVypraveniSettingsDto | null | undefined = content.globalSettings!.get(VypraveniSettingsPath, true);
        if (settings)
        {
            return settings;
        }
        else
        {
            return {
                text_za: "",
                text_pred: "",
                posledniPodaciCislo: null,
                poplatek: null,
                vaha: null,
                stat: 42,
                psc: "",
                dotaz_pri_vypraveni: true,
            };
        }
    }

    /**
     * Nastaví hodnoty uživatelského nastavení zásilky.
     *  
     * @author  JSindelka
     * @date    30.04.2019
     *  
     * @param {Gordic.Vyp.AppSettings.IGVypraveniSettings | null} value Hodnoty uživatelského nastavení zásilky.
     */
    export function SetVypraveniSettings(content: GContent, value: Gordic.Wfl.Interface.GVypraveniSettingsDto | null): void {
        content.globalSettings!.merge(VypraveniSettingsPath, value!);
    }

    /**
     * Formulář uživatelského nastavení vypravení.
     *
     * @author  JSindelka
     * @date    30.04.2019
     */
    export function VypraveniSettingsForm(): Forms.Form {
        const formName = "VypraveniSettingsForm";
        let modelProperty: (keyof Gordic.Wfl.Interface.GVypraveniSettingsDto) | undefined;

        const form = new Gordic.Forms.Form({
            name: formName,
            tabOptions: {
                title: "jres:23900055", //RC 23900055 : Vypravení zásilek
                opened: false
            }
        } as any);

        //Nastavení počátečních hodnot pro vypravení zásilek
        form.addSection("jres:23900138") //RC 23900138 : Nastavení chování aplikace při vypravení zásilek
        form.addRow().addField("gcheck", "", { name: "zasilky_k_vypraveni_neoznacovat", model: VypraveniSettingsPath + "." + (modelProperty = "zasilky_k_vypraveni_neoznacovat"), label: "jres:23900139" }); //RC 23900139 : Zásilky k vypravení standardně neoznačovat
        form.addRow().addField("gcheck", "", { name: "dotaz_pri_vypraveni", model: VypraveniSettingsPath + "." + (modelProperty = "dotaz_pri_vypraveni"), label: "jres:23900140" }); //RC 23900140 : Dotaz na potvrzení operace vypravení

        form.addSection("jres:23900056") //RC 23900056 : Nastavení počátečních hodnot pro vypravení zásilek
        form.addRow("jres:23900021" + ", " + "jres:23900022")
            .addField("gselectbox", "w-4", Gordic.Prefabs.Select.ginspsc(), 
            {
                name: fieldNames.psc,
                model: VypraveniSettingsPath + "." + (modelProperty = "psc") + "=value.psc; " +
                    VypraveniSettingsPath + "." + (modelProperty = "stat") + "=value.stat",
                change: function (event, input) {
                    if (input && input.value) {
                        const statField = $(event.target).gform().findForms(formName).findFields(fieldNames.stat);
                        statField.gfield<Gordic.Data.Readers.GincstaDto>("setInitial", { stat: input.value.stat }, false);
                    }
                }
            }) //RC 23900021 : PSČ

            .addField("gselectbox", "w-8", Gordic.Prefabs.Select.gincsta(), {
                name: fieldNames.stat, model: VypraveniSettingsPath + "." + (modelProperty = "stat") + "=value.stat"
            }) //RC 23900022 : Stát
        form.addRow().addField("gcheck", "", { name: "novePodaciCislo", model: VypraveniSettingsPath + "." + (modelProperty = "novePodaciCislo"), label: "jres:23900189" }); //RC 23900189 : Nové podací číslo

        form.addRow("jres:23900023").addField("gselectbox", Gordic.Prefabs.Select.wflsdos(), { name: "dor_sluzba", model: VypraveniSettingsPath + "." + (modelProperty = "dor_sluzba") + "=value.dor_sluzba"}) //RC 23900023 : Doručovací služba

        form.addRow("jres:23900043" + ", " + "jres:23900044" + ", " + "jres:23900045") //RC 23900046 : Nové pod. číslo
            .addField("gstringbox", "w-3", { name: "text_pred", model: VypraveniSettingsPath + "." + (modelProperty = "text_pred") })
            .addField("gnumberbox", "w-3", { name: "posledniPodaciCislo", model: VypraveniSettingsPath + "." + (modelProperty = "posledniPodaciCislo") })
            .addField("gstringbox", "w-3", { name: "text_za", model: VypraveniSettingsPath + "." + (modelProperty = "text_za") })
            //.addField("gcheck", "", { name: "novePodaciCislo" }) 
            .addRow("jres:23900015" + ", " + "jres:23900016") //RC 23900015 : Poplatek
            .addField("gnumberbox", "w-3", { name: "poplatek", model: VypraveniSettingsPath + "." + (modelProperty = "poplatek"),  decimals: 4, minValue: 0, maxValue: 99.9999 })
            .addField("gnumberbox", "w-3", { name: "vaha", model: VypraveniSettingsPath + "." + (modelProperty = "vaha"), decimals: 4, minValue: 0, maxValue: 99.9999 });

        //Frankování
        form.addSection("jres:23900116");//RC 23900116 : Frankování
        form.addRow({ label: "jres:23900124" }).addField("gradio", { //RC 23900124 : Typ
            name: "typ_frankovani",
           // model: VypraveniSettingsPath + "." + (modelProperty = "typ_frankovani"),
            model: function (operation, dto, modelOptions) {
                switch (operation) {
                    case "apply":  // naplneni multivalue policka z DTO
                        var l_val = dto.Global.Vyp.AppSettings.VypraveniSettings.typ_frankovani;
                        if (l_val == null) l_val = Wfl.Interface.TypFrankovacihoStroje.neurceno;             
                        //$(this).gfield("setValue", l_val); //dsebesta 19.05.2022
                        $(this).gfield("setInitial", l_val);
                        $(this).gfield("confirm");
                        return;
                    case "collect": // naplneni DTO hodnotou z multivalue policka (vraci vzdy pole)                      
                        var l_po = $(this).gfield("getValue");
                        //if (l_po != null) Gordic.Utils.setValueByKeyPath("Global.Vyp.AppSettings.VypraveniSettings.typ_frankovani", dto, l_po) 
                        if (l_po != null) Gordic.Utils.setValueByKeyPath(VypraveniSettingsPath + "." + (modelProperty = "typ_frankovani"), dto, l_po) 
                        return;
                }
                return "typ_frankovani"; 
            },

            radios: [
                    { value: Wfl.Interface.TypFrankovacihoStroje.neurceno, label: 'jres:23900119' }, //RC 23900119 : Žádné
                    { value: Wfl.Interface.TypFrankovacihoStroje.FramaSoubor, label: 'jres:23900120' }, //RC 23900120 : Frama - import ze souboru
                    { value: Wfl.Interface.TypFrankovacihoStroje.NeopostDataMatrixCtecka, label: 'jres:23900118' }, //RC 23900118 : Neopost - data-matrixová čtečka
            ], change: function (event, input)
            {

                let l_disableDataMatrixSettings = true;
                let l_disableFramaFileSettings = true;
                if (input.value)
                {                  
                    switch (input.value)
                    {
                        case Wfl.Interface.TypFrankovacihoStroje.NeopostDataMatrixCtecka:
                            l_disableDataMatrixSettings = false;
                            break;
                        case Wfl.Interface.TypFrankovacihoStroje.FramaSoubor:
                            l_disableFramaFileSettings = false;
                            break;
                    }
                }

                var l_form = $(this).closest(".gform");

                if (l_form) {
                    l_form.findFields(fieldNames.tridit_dle_souboru).gfield("option", "disabled", l_disableFramaFileSettings);
                    l_form.findFields(fieldNames.kontrolovat_spravnost_dle_souboru).gfield("option", "disabled", l_disableFramaFileSettings);
                    l_form.findFields(fieldNames.opravit_data_dle_souboru).gfield("option", "disabled", l_disableFramaFileSettings);
                    l_form.findFields(fieldNames.pouzivat_soubor_bez_pidu).gfield("option", "disabled", l_disableFramaFileSettings);

                    l_form.findFields(fieldNames.frankovani_pretridit).gfield("option", "disabled", l_disableDataMatrixSettings);
                    l_form.findFields(fieldNames.frankovani_podaci_cislo).gfield("option", "disabled", l_disableDataMatrixSettings);
                    l_form.findFields(fieldNames.frankovat_pri_prevzeti).gfield("option", "disabled", l_disableDataMatrixSettings);
                }
            },
        });  

        form.addRow().addField("gcheck", "", { name: fieldNames.tridit_dle_souboru, model: VypraveniSettingsPath + "." + (modelProperty = fieldNames.tridit_dle_souboru), label: "jres:23900143" }); //RC 23900143 : Třídit zásilky dle souboru
        form.addRow().addField("gcheck", "", { name: fieldNames.kontrolovat_spravnost_dle_souboru, model: VypraveniSettingsPath + "." + (modelProperty = fieldNames.kontrolovat_spravnost_dle_souboru), label: "jres:23900144" }); //RC 23900144 : Kontrolovat správnost zásilek dle souboru
        form.addRow().addField("gcheck", "", { name: fieldNames.opravit_data_dle_souboru, model: VypraveniSettingsPath + "." + (modelProperty = fieldNames.opravit_data_dle_souboru), label: "jres:23900145" }); //RC 23900145 : Opravit zásilky v GINISu dle souboru
        form.addRow().addField("gcheck", "", { name: fieldNames.pouzivat_soubor_bez_pidu, model: VypraveniSettingsPath + "." + (modelProperty = fieldNames.pouzivat_soubor_bez_pidu), label: "jres:23900146" }); //RC 23900146 : Používat soubor bez PIDů

        form.addRow().addField("gcheck", "", { name: fieldNames.frankovani_pretridit, model: VypraveniSettingsPath + "." + (modelProperty = fieldNames.frankovani_pretridit), label: "jres:23900122" }); //RC 23900122 : Přetřídit dle frankování
        form.addRow().addField("gcheck", "", { name: fieldNames.frankovani_podaci_cislo, model: VypraveniSettingsPath + "." + (modelProperty = fieldNames.frankovani_podaci_cislo), label: "jres:23900123" }); //RC 23900123 : Snímat i podací číslo

        //Tisk podacího archu a výkazu
        form.addSection("jres:23900103")//RC 23900103 : Tisk podacího archu a výkazu
            .addRow("jres:23900057") //RC 23900058 : Uživatel VS
            .addField("gstringbox", "w-6", { name: "cislo_podavatele", model: VypraveniSettingsPath + "." + (modelProperty = "cislo_podavatele") })
            .addRow( "jres:23900058") //RC 23900058 : Uživatel VS
            .addField("gstringbox", "w-6", { name: "uzivatel_vs", model: VypraveniSettingsPath + "." + (modelProperty = "uzivatel_vs") });
        form.addRow("jres:23900137") //RC 23900137 : Číslo zákaznické karty odesilatele
            .addField("gstringbox", "w-6", { name: "cislo_zakaznicke_karty_odesilatele", model: VypraveniSettingsPath + "." + (modelProperty = "cislo_zakaznicke_karty_odesilatele") });
    
        form.addSection("jres:23900059") //RC 23900059 : Nastavení pro generování elektronického podacího archu (ePA)
            .addRow("jres:23900134") //RC 23900134 : Identifikace podavatele pro ePA
            .addField("gstringbox", "w-6", { name: "epa_identifikace_podavatele", model: VypraveniSettingsPath + "." + (modelProperty = "epa_identifikace_podavatele") })
            .addRow("jres:23900136") //RC 23900136 : Jméno souboru [.CSV]
            .addField("gstringbox", "w-6", { name: "epa_jmeno_souboru", model: VypraveniSettingsPath + "." + (modelProperty = "epa_jmeno_souboru") })
            .addRow("jres:23900135") //RC 23900135 : Údaje o odesílateli pro ePA v definovaném formátu
            .addField("gstringbox", { name: "epa_data_odesilatele", model: VypraveniSettingsPath + "." + (modelProperty = "epa_data_odesilatele") })

        form.addRow().addField("gcheck", "", { name: "epa_jednoznacne_jmeno", model: VypraveniSettingsPath + "." + (modelProperty = "epa_jednoznacne_jmeno") , label: "jres:23900060" }); //RC 23900060 : Generovat jednoznačné jméno

        // ceniky
        form.addSection("jres:23900094") //RC 23900094 : Ceníky
            .addRow()
            .addField("gbuttonpanel", {
                params: [
                    {
                        action: new GAction({
                            name: "actCenikSluzeb",
                            caption: "jres:23900093", //RC 23900093 : Poplatek za služby
                            tooltip: "jres:23900093",
                            run: function (event, actionContext) {
                                Gordic.Vyp.Dialogs.CenikSluzebDlg(undefined as any, Gordic.Global.Enums.ModOtevreni.showModalWindow) 
                            }
                        })
                    },
                    {
                        action: new GAction({
                            name: "actCenikZasilek",
                            caption: "jres:23900095", //RC 23900095 : Poplatek za zásilky
                            tooltip: "jres:23900093",
                            run: function (event, actionContext) {
                                Gordic.Vyp.Dialogs.CenikZasilekDlg(undefined as any, Gordic.Global.Enums.ModOtevreni.showModalWindow) 
                            }
                        })
                    }
                ]
            })

        return form;
    }
}